import { AppRoutes } from '../../gt2/const/AppRoutes';
import { IconsService } from '../../gt2/services/icons.service';
import { GroupNavigationInterface } from './GroupNavigationInterface';
// const prefix = localStorage.getItem('PREFIX');
// const prefixUrl = prefix ? prefix + '/' : '';
// const prefixUrl = '';
const prefix = localStorage.getItem('PREFIX') || '';

export class GodGroupNavigationModel implements GroupNavigationInterface {
  id: string = 'godMenu';
  title: string = 'God';
  translate: string = 'NAV.GOD';
  type: string = 'collapsable';
  children: any[] = [
    {
      id: 'godReports',
      title: 'Rapports',
      translate: 'NAV.GOD_REPORTS.TITLE',
      type: 'item',
      icon: 'picture_as_pdf',
      url: prefix + '/god-reports',
    },
    {
      id: 'loginLocalStorage',
      title: 'Local Storage',
      translate: 'NAV.GOD_LOCAL_STORAGE.TITLE',
      type: 'item',
      icon: 'storage',
      url: prefix + '/god-local-storage',
    },
    {
      // Historique des courriels — page « Courriels envoyés », GOD seulement.
      // Masquée par app.component si l'organisation n'a pas MODULE_EMAIL_HISTORY.
      id: 'sent-emails',
      title: 'Courriels envoyés',
      translate: 'NAV.SENT_EMAILS.TITLE',
      type: 'item',
      icon: IconsService.EMAIL_HISTORY,
      url: prefix + '/' + AppRoutes.SENT_EMAILS,
    },
    {
      id: 'godEmails',
      title: 'Emails',
      translate: 'NAV.GOD_EMAILS.TITLE',
      type: 'item',
      icon: 'email',
      url: prefix + '/god-emails',
    },
    {
      id: 'test',
      title: 'Test Page (dev)',
      translate: 'NAV.TEST.TITLE',
      type: 'item',
      icon: 'adjust',
      url: prefix + '/test',
    },
    {
      id: 'godChat',
      title: 'Chat',
      type: 'item',
      icon: 'chat',
      url: prefix + '/chat',
    },
    {
      id: 'roomManagement',
      title: 'Gestion des salles',
      translate: 'NAV.ROOM_MANAGEMENT.TITLE',
      type: 'item',
      icon: 'room',
      url: prefix + '/gestion-salles',
    },
    // {
    //     'id': 'impersonation',
    //     'title': 'Impersonation',
    //     'translate': 'NAV.GOD_IMPERSONATION.TITLE',
    //     'type': 'item',
    //     'icon': 'swap_calls',
    //     'url': '/god-impersonation'
    // }
  ];
}
